/**
 * Personal Information Section Component
 *
 * @module @features/departments/components/PersonalInfo
 */

import React from 'react';
import { useI18n } from '@shared/i18n';
import type { Employee } from '@shared/types';
import { NameAndValue } from './NameAndValue';

/**
 * Props for PersonalInfo component
 */
export interface PersonalInfoProps {
    employee: Employee | undefined;
}

/**
 * Displays personal information about an employee
 */
export function PersonalInfo({
    employee,
}: PersonalInfoProps): React.ReactElement {
    const { t } = useI18n();

    return (
        <>
            <NameAndValue
                name={t('departments.personal.name')}
                value={employee?.name}
            />
            <NameAndValue
                name={t('departments.personal.position')}
                value={employee?.restPosition?.name}
            />
            <NameAndValue
                name={t('departments.personal.vacancyRate')}
                value={((): string => {
                    const v = (employee?.vacancyRate ?? 0) / 100;
                    return `${v % 1 === 0 ? v.toFixed(0) : v.toFixed(2)}%`;
                })()}
            />
        </>
    );
}
